import React from "react";

/**
 * REIN TCPA disclosure text. Accepts `buttonLabel` to match the
 * exact CTA text on the page where it's rendered.
 */
const ReinTcpaDisclosure = ({ buttonLabel = "Accept Offer" }) => (
  <p className="text-[10px] leading-tight text-gray-400">
    By clicking {buttonLabel} and submitting this form, I am providing express
    written consent to being contacted by REIN to discuss my interests, including offers of insurance, at
    the phone number and/or email address I have provided to you in submitting
    this form and/or additional information obtained. I consent by electronic
    signature to being contacted by telephone (via call and/or text) for
    marketing/telemarketing purposes at the phone number I provided in this
    form, even if my phone number is listed on a Do Not Call Registry, and I
    agree that such contact may be made using an automatic telephone dialing
    system and/or an artificial or prerecorded voice (standard call, text
    message, and data rates apply). I can revoke my consent at any time. I also
    understand that my agreement to be contacted is not a condition of
    purchasing any property, goods or services, and that I may call +1 (866)
    355-2580 to speak with someone about obtaining an insurance quote. By
    submitting this form, I affirm that I have read and agree to this
    website's{" "}
    <a
      href="https://www.rein.ai/privacypolicy"
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#7B61FF] underline"
    >
      Privacy Policy
    </a>{" "}
    and{" "}
    <a
      href="https://www.rein.ai/termsofservice"
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#7B61FF] underline"
    >
      Terms of Service
    </a>{" "}
    including the arbitration provision.
  </p>
);

export default ReinTcpaDisclosure;
